/**
 * Returns a true boolean value if the brand contains anyday
 * @param {string} brand - brand name property
 * @returns {boolean} The passed value is the anyday brand
 */
export const isAnydayBrand = (brand?: string): boolean =>
  typeof brand === "string"
    ? Boolean(brand?.match(new RegExp(/^anyday|^john lewis anyday/, "i")))
    : false;

/**
 * Escape any regex special characters in a string so that the escaped string can be used in a regex
 * @param string {string} : 'Dr. Jart+'
 * @returns {string} : 'Dr\. Jart\+'
 */

export const escapeRegexSpecialChars = (string: string) =>
  string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string

export const getTitleWithoutBrand = (
  title: string = "",
  brand: string = "",
  isAnydayBrand: boolean = false,
) => {
  if (!brand || !title) {
    return title;
  }

  return isAnydayBrand
    ? title
        .replace(
          new RegExp(/^anyday john lewis & partners|^john lewis anyday/, "i"),
          "",
        )
        .trim()
    : title
        .replace(new RegExp(`^${escapeRegexSpecialChars(brand)}`, "i"), "")
        .trim();
};
